import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mainCategoryServices } from '../services/main-category.service';
import toast from 'react-hot-toast';

export const useToggleCategoryStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ categoryId, isActive }) => mainCategoryServices.toggleActiveStatus(categoryId, { isActive }),

    // Optimistic update
    onMutate: async ({ categoryId, isActive }) => {
      // Cancel outgoing refetches
      await queryClient.cancelQueries({ queryKey: ['main-category'] });

      // Snapshot previous values
      const previousData = queryClient.getQueriesData({ queryKey: ['main-category'] });

      // Optimistically update all matching queries
      queryClient.setQueriesData({ queryKey: ['main-category'] }, (old) => {
        if (!old) return old;

        return {
          ...old,
          data: old.data?.map((category) => (category._id === categoryId ? { ...category, isActive } : category)),
        };
      });

      return { previousData };
    },

    onError: (error, variables, context) => {
      // Rollback on error
      if (context?.previousData) {
        context.previousData.forEach(([queryKey, data]) => {
          queryClient.setQueryData(queryKey, data);
        });
      }
      toast.error(error?.response?.data?.message || 'Failed to update category status');
    },

    onSuccess: () => {
      toast.success('Category status updated successfully');
    },

    onSettled: () => {
      // Refetch to ensure consistency
      queryClient.invalidateQueries({ queryKey: ['main-category'] });
    },
  });
};
